import { AxiosInterceptor, AxiosInterceptorOptions } from "./types";
import { sortByPrio } from "./utils";

export class AxiosPrioInterceptorManager<V> {
  handlers: (AxiosInterceptor<V> | null)[] = [];
  constructor() {}
  use(
    fulfilled?: (value: V) => V | Promise<V>,
    rejected?: (error: any) => any,
    options?: AxiosInterceptorOptions
  ) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null,
      prio: options ? options.prio : undefined
    });
    return this.handlers.length - 1;
  }
  eject(id: number) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }
  forEach(fn: Function) {
    sortByPrio(this.handlers).forEach(function forEachHandler(i) {
      i !== null && fn(i);
    });
  }
}
